import React from "react";
import { Container } from "react-bootstrap";

const Blogs = () => {
  return (
    <Container className="p-5">
      <article>
        <h2>Best Practices for Strong Teeth</h2>
        <h4>
          Good oral hygiene is necessary to keep teeth and gums healthy. It
          involves habits such as brushing twice a day and having regular dental
          checkups.
        </h4>
        <p>
          However, oral health is about more than cavities and gum disease.
          Research has shown that there is an association between the health of
          a person’s mouth and their overall health. Experts consider oral
          health problems to be a global health burdenTrusted Source. Without
          treatment, tooth decay or gum problems can lead to pain, problems with
          self-confidence, and tooth loss. These issues may lead to
          malnutrition, speech problems, and other challenges in a person’s
          work, school, or personal life. People can prevent these problems with
          proper dental care, both at home and in the dentist’s office. The
          following are some best practices that can keep teeth and gums
          healthy.
        </p>

        <h5>1. Brush regularly but not aggressively</h5>
        <p>
          Most people are aware that brushing their teeth twice a day is one of
          the most important practices for removing plaque and bacteria and
          keeping teeth clean. However, brushing may only be effective if people
          use the correct technique. People should brush using small circular
          motions, taking care to brush the front, back, and top of every tooth.
          This process takes between 2 and 3 minutes. People should avoid sawing
          back-and-forth motions. Brushing too hard or using a hard-bristled
          toothbrush can damage tooth enamel and the gums. The effects of this
          may include tooth sensitivity, permanent damage to the protective
          enamel on the teeth, and gum erosion.
        </p>
        <h5>2. Use fluoride</h5>
        <p>
          Fluoride comes from an element in the earth’s soil called fluorine.
          Many experts believe that fluoride helps prevent cavities, and it is a
          common ingredient in toothpaste and mouthwash. However, some dental
          products do not contain fluoride, and some people do not use it at
          all. Evidence suggests that a lack of fluoride can lead to tooth
          decay, even if a person takes care of their teeth otherwise. A recent
          review found that brushing and flossing do not preventTrusted Source a
          person from getting cavities if they do not use fluoride.
        </p>
        <h5>3. Floss once a day</h5>
        <p>
          Flossing can remove plaque and bacteria from between the teeth, where
          a toothbrush is unable to reach. It can also help prevent bad breath
          by removing debris and food that has become trapped between the teeth.
          Although there is a lack of long-term studies proving that flossing is
          beneficial, the ADA continue to recommend it. The CDCTrusted Source
          also state that people should floss their teeth. Most dental health
          professionals recommend gently pushing the floss all the way down to
          the gumline before hugging the side of the tooth with up-and-down
          motions. It is important to avoid snapping the floss up and down
          between the teeth, which can cause pain and will not remove plaque as
          effectively.
        </p>
        <h5>4. See a dentist regularly</h5>
        <p>
          Experts recommend that people see a dentist every 6 months for a
          checkup. During a routine dental examination, a hygienist will clean
          the teeth and remove plaque and hardened tartar. The dentist will
          check for visual signs of cavities, gum disease, mouth cancer, and
          other oral health issues. They may sometimes also use dental X-rays to
          check for cavities. The results of a recent study confirmed that
          children and adolescents should see a dentist every 6 months to help
          prevent cavities. However, adults who practice good dental hygiene
          every day and have a low risk of oral health problems may be able to
          go less frequently. The authors of a recent reviewTrusted Source state
          that there is a need for more high-quality studies to confirm the
          ideal frequency of dental checkups. People can speak to their dentist
          about how often they need a checkup. The answer may vary depending on
          a person’s health history, age, and overall dental health. However,
          anyone who notices changes in their mouth should visit a dentist.
        </p>
        <h5>5. Do not smoke</h5>
        <p>
          Smoking harms the body’s immune system, which makes it difficult for
          the body to heal tissues, including those in the mouth. The CDC name
          smoking as a risk factor for gum diseaseTrusted Source, while the ADA
          warn that people who smoke may experience slow healing after a dental
          procedure. Smoking also affects the appearance of the mouth, leading
          to yellowing of the teeth and tongue, and it can give breath a bad
          odor.
        </p>
      </article>
    </Container>
  );
};

export default Blogs;
